function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 7.18,
  d: "M64.03 9.11h-64M64.03 31.99h-64M64.03 54.86h-64"
});

function SvgBurgerMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgdmlld0JveD0iMCAwIDY0IDY0Ij48dGl0bGU+YnVyZ2VyLW1lbnU8L3RpdGxlPjxsaW5lIHgxPSI2NC4wMyIgeTE9IjkuMTEiIHgyPSIwLjAzIiB5Mj0iOS4xMSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgc3Ryb2tlLXdpZHRoPSI3LjE4Ii8+PGxpbmUgeDE9IjY0LjAzIiB5MT0iMzEuOTkiIHgyPSIwLjAzIiB5Mj0iMzEuOTkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiIHN0cm9rZS13aWR0aD0iNy4xOCIvPjxsaW5lIHgxPSI2NC4wMyIgeTE9IjU0Ljg2IiB4Mj0iMC4wMyIgeTI9IjU0Ljg2IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2Utd2lkdGg9IjcuMTgiLz48L3N2Zz4=";
export { SvgBurgerMenu as ReactComponent };